/**
 * Dit à l'écran si ce qu'il montre arrive en temps réel ou par relecture périodique.
 *
 * C'est la télémétrie visible du flux : s'il tombe, l'utilisateur le voit au lieu de
 * croire à un parc figé. Le texte dit le rythme réellement appliqué, jamais une promesse.
 */
const LIBELLES = {
  temps_reel: { texte: 'Temps réel', point: 'bg-emerald-500', titre: 'Mis à jour dès qu\'un actif change' },
  connexion: { texte: 'Connexion…', point: 'bg-amber-400', titre: 'Ouverture du flux temps réel' },
  interrompu: { texte: 'Toutes les 10 s', point: 'bg-amber-400', titre: 'Flux interrompu : relecture toutes les 10 secondes, reconnexion en cours' },
  indisponible: { texte: 'Toutes les 10 s', point: 'bg-neutral-400', titre: 'Temps réel indisponible pour ce compte : relecture toutes les 10 secondes' },
};

export default function IndicateurFlux({ etat, actif = true }) {
  if (!actif) return null;
  const l = LIBELLES[etat] || LIBELLES.interrompu;
  return (
    <span
      className="inline-flex items-center gap-1.5 text-[11px] text-neutral-500"
      title={l.titre}
      data-testid="indicateur-flux"
      data-etat={etat}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${l.point}`} />
      {l.texte}
    </span>
  );
}
